'use strict';

namespace Core {

    class AddFlightDetailsModal {

        show: boolean;
        private hotel: any;
        private priceMode: number;
        private totalNonInfants: number;
        private transfers: any[] = [];
        public transferExtras: any;
        private roomId: string;
        private priceId: any[];
        private roomsWithTransfers: any;
        private multipleRoomMode: boolean;
        public includedTransfer: any;
        private roomCost: number;
        public flightDetails: {
            transfer: any,
            transfers: any,
            options: any,
            outboundFlightNum: string,
            arrivalTime: {hours: string, minutes: string},
            inboundFlightNum: string,
            departureTime: {hours: string, minutes: string},
        };

        constructor(
            private $scope: ng.IScope,
            private broker: any,
            private mandatoryTransferService
            )
        {
            this.hotel = $scope.hotel;
        }

        init (container : ng.IAugmentedJQuery) {
            this.broker.subscribe('modalAddFlightDetails', 'showModalAddFlightDetails',  e => {
                this.transfers = this.mandatoryTransferService.getTransfers(e.data.roomInfo.Extras || []);
                this.includedTransfer = this.mandatoryTransferService
                                          .findSelectedTransfer(this.transfers, e.data.roomInfo.IncludedExtras);
                this.flightDetails.transfer = this.includedTransfer || this.transfers[0];
                this.roomId = e.data.roomId;
                this.priceId = [e.data.priceId];
                this.show = true;
                this.multipleRoomMode = false;
                this.priceMode = e.data.priceMode;
                this.totalNonInfants = e.data.totalNonInfants;
                this.roomCost = e.data.roomInfo.TotalCost;
            });

            this.broker.subscribe('modalAddFlightDetails', 'showModalAddFlightDetailsForMultiRooms',  e => {
                this.show = true;
                this.multipleRoomMode = true;
                this.priceMode = e.data.priceMode;
                this.roomsWithTransfers = e.data.rooms;
                this.includedTransfer = [];
                this.flightDetails.transfers = [];
                this.transfers = [];
                this.transferExtras = [];
                this.includedTransfer = [];
                this.priceId = [];
                for(let i = 0; i < this.roomsWithTransfers.length; i++) {
                    this.flightDetails.transfers[i] = this.mandatoryTransferService
                        .findSelectedTransfer(this.roomsWithTransfers.mandatoryTransfers,
                        this.roomsWithTransfers[i].IncludedExtras)
                 || this.roomsWithTransfers[i].mandatoryTransfers[0];

                 this.transfers = this.roomsWithTransfers[i].mandatoryTransfers ||
                    this.roomsWithTransfers[i].IncludedExtras;
                    this.priceId.push(this.roomsWithTransfers[i].Id);
                    this.transferExtras = this.mandatoryTransferService.getTransfers(
                    this.roomsWithTransfers[i].Extras || []);
                    this.includedTransfer[i] = this.mandatoryTransferService
                    .findSelectedTransfer(this.transferExtras,
                         this.roomsWithTransfers[i].IncludedExtras);

                }
            });

            this.broker.subscribe('modalAddFlightDetails', 'HotelAvailabilityReceive',  e => {
                this.hotel.Availability = e.data.Availability;
            });

            this.broker.subscribe('modalAddFlightDetails', 'roomsSet', e => {
                this.hotel.Availability = e.data.RequestedRooms[0].Availability;
            });

            this.$scope.$on('$destroy', () => {
                this.broker.unsubscribe('modalAddFlightDetails');
            });
        }

        continueToBook() {
            if(!this.multipleRoomMode) {
                this.broker.publish('continueToBookFromFlightDetailsModal', {
                    roomId: this.roomId,
                    priceId: this.priceId,
                    flightDetails: this.flightDetails
                });
                this.mandatoryTransferService.generateMandatoryOptions(this.roomId, this.flightDetails);
            } else {
                this.flightDetails.options = this.mandatoryTransferService
                                                 .generateOptionsForMultiRooms(this.flightDetails,
                                                                               this.roomsWithTransfers);
                this.mandatoryTransferService.generateMandatoryOptions(this.roomId, this.flightDetails);
                this.broker.publish('continueToBookFromFlightDetailsModal', {
                    multipleRoomMode: this.multipleRoomMode,
                    flightDetails: this.flightDetails,
                    priceId: this.priceId
                });
            }

        }

    }

    angular
        .module('core')
        .directive('addFlightDetailsModal', (): ng.IDirective => {

        return {
            scope: {hotel: '='},
            controller: AddFlightDetailsModal,
            controllerAs: 'afdc',
            templateUrl: 'partials/home/directivetemplate?type=AddFlightDetailsModal',

            link: function (scope : ng.IScope, el : ng.IAugmentedJQuery, attr, controller : AddFlightDetailsModal) {
                controller.init(el);
            }

        };

    });

}
